import { Tooltip, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useAppDispatch, useAppSelector } from "store/hook";
import { ReloadOutlined } from "@ant-design/icons";

const Refresh_Simple = ({ queriesArray, extraFunc }: { queriesArray: string[]; extraFunc?: Function }) => {
  const { t } = useTranslation();
  const { stateCid } = useAppSelector((state) => state.global);
  // const { modbusNodeList, diNodeList, doNodeList, lanNodeList } = useAppSelector((state) => state.dashboard);

  const queryClient = useQueryClient();
  const disp = useAppDispatch();
  // 取得 Device資料
  return (
    <Tooltip title={t("ISMS.Refresh")}>
      <Button
        icon={<ReloadOutlined />}
        onClick={() => {
          return queriesArray.forEach((query) => queryClient.invalidateQueries([query]));
        }}
      ></Button>
    </Tooltip>
  );
};

export default Refresh_Simple;
